'use client'

import { ReactNode, useCallback, useContext } from 'react'

import { readExperimentAssignments } from '@/lib/analytics/experiment-exposures'
import { utmize as _utmize } from '@/lib/analytics/utmize'

import { AffiliateLinkContext, AffiliateLinkProps } from './affiliate-link-context'
import { useAnalytics } from './analytics-provider'
import { ClientContext } from './client-context'

export const AffiliateLinkProvider = ({ children }: { children: ReactNode }) => {
  const { segment, distinctId } = useAnalytics()
  const { pageType } = useContext(ClientContext)
  const buildLink = useCallback(
    (props: AffiliateLinkProps) => {
      if (typeof window === 'undefined') return props.url
      const { pathname, search } = window.location
      return _utmize({
        ...props,
        pathname,
        search,
        segment,
        pageType,
        experiments: readExperimentAssignments(distinctId ?? 'anonymous'),
      })
    },
    [pageType, segment, distinctId]
  )
  return <AffiliateLinkContext.Provider value={{ buildLink }}>{children}</AffiliateLinkContext.Provider>
}

export const useAffiliateLink = () => useContext(AffiliateLinkContext)
